import React, { useState, useEffect, useContext, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { AuthContext } from "../../../contexts/AuthContext";
import { useStateContext } from "../../../contexts/ContextProvider";
import { postRequest } from "../../../constants/api";
import {
  ShowTableSetoranAngsuranKelompok,
  ShowTableTampilPenerimaanAngsuranKelompok,
} from "../../../components/ShowTable";
import { FetchErrorHandling } from "../../../components/FetchErrorHandling";
import { SearchBar, Loader, ButtonModifier } from "../../../components";
import { formatDate } from "../../../constants/helper";
import { Container, Form, Row, Col } from "react-bootstrap";
import { Box, Pagination, Button, ButtonGroup } from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import SearchIcon from "@mui/icons-material/Search";
import jsPDF from "jspdf";
import "jspdf-autotable";
import angkaTerbilang from "@develoka/angka-terbilang-js";
import { useDownloadExcel } from "react-export-table-to-excel";
import DownloadIcon from "@mui/icons-material/Download";
import PrintIcon from "@mui/icons-material/Print";
import useScreenWidth from "../../../hooks/useScreenWidth";

const TampilSetoranAngsuranKelompok = () => {
  const screenSize = useScreenWidth();
  const tableRef = useRef(null);

  // IMPORTANT: use array refs for each kwitansi
  const kwitansiRefs = useRef([]);

  const { user, dispatch, setting } = useContext(AuthContext);
  const location = useLocation();
  const id = location.pathname.split("/")[2];

  const [isFetchError, setIsFetchError] = useState(false);

  // Angsuran
  const [kelompokId, setKelompokId] = useState("");
  const [angsuranKelompokId, setAngsuranKelompokId] = useState("");
  const [noKwitansi, setNoKwitansi] = useState("");
  const [noKelompok, setNoKelompok] = useState("");
  const [no, setNo] = useState("");
  const [tglJatuhTempo, setTglJatuhTempo] = useState("");
  const [angPerBulan, setAngPerBulan] = useState("");
  const [totalAngsuran, setTotalAngsuran] = useState("");
  const [tglBayar, setTglBayar] = useState("");
  const [bayar, setBayar] = useState("");

  const [setoranAngsuranKelompoks, setSetoranAngsuranKelompoks] = useState([]);
  const [penerimaanAngsuranKelompoks, setPenerimaanAngsuranKelompoks] =
    useState([]);

  const [
    penerimaanAngsuranKelompokReport,
    setPenerimaanAngsuranKelompokReport,
  ] = useState([]);
  const [previewPdf, setPreviewPdf] = useState(false);
  const [previewExcel, setPreviewExcel] = useState(false);
  const [previewPdfCetakKwitansi, setPreviewPdfCetakKwitansi] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  let [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [pages, setPages] = useState(0);
  const [rows, setRows] = useState(0);
  const [query, setQuery] = useState("");

  const handleChange = (e, p) => {
    setPage(p - 1);
  };

  const searchData = (e) => {
    e.preventDefault();
    setPage(0);
    setSearchTerm(query);
  };

  useEffect(() => {
    getSetoranAngsuranKelompokById();
  }, [id]);

  useEffect(() => {
    getSetoranAngsuranKelompoks();
  }, [page, searchTerm]);

  const getSetoranAngsuranKelompoks = async () => {
    setLoading(true);
    try {
      const response = await postRequest(
        `/setoranAngsuranKelompoksPagination?search_query=${searchTerm}&page=${page}&limit=${limit}`,
        {},
        navigate,
        dispatch,
      );
      setQuery(searchTerm);
      setSetoranAngsuranKelompoks(response.data.setoranAngsuranKelompoks);
      setPage(response.data.page);
      setPages(response.data.totalPage);
      setRows(response.data.totalRows);
    } catch (error) {
      setIsFetchError(true);
    }
    setLoading(false);
  };

  const getPenerimaanAngsuranKelompokReportData = async () => {
    try {
      const response = await postRequest(
        `/setoranAngsuranKelompoks`,
        {},
        navigate,
        dispatch,
      );
      setPenerimaanAngsuranKelompokReport(response.data);
    } catch (error) {
      setIsFetchError(true);
    }
  };

  const getSetoranAngsuranKelompokById = async () => {
    setLoading(true);
    if (id) {
      const response = await postRequest(
        `/setoranAngsuranKelompoks/${id}`,
        {},
        navigate,
        dispatch,
      );

      // Angsuran
      setKelompokId(response.data.angsurankelompok.kelompok.id);
      setAngsuranKelompokId(response.data.angsurankelompok.id);
      setNoKwitansi(response.data.noKwitansi);
      setNoKelompok(response.data.angsurankelompok.kelompok.noKelompok);
      setNo(response.data.angsurankelompok.no);
      setTglJatuhTempo(new Date(response.data.angsurankelompok.tglJatuhTempo));
      setAngPerBulan(response.data.angPerBulan);
      setTotalAngsuran(response.data.totalAngsuran);
      setTglBayar(new Date(response.data.tglBayar));
      setBayar(response.data.bayar);

      const findChild = await postRequest(
        `/penerimaanAngsuranKelompoksBySetoranAngsuranKelompok`,
        {
          setoranAngsuranKelompokId: id,
        },
        navigate,
        dispatch,
      );

      setPenerimaanAngsuranKelompoks(findChild.data);

      // reset refs length so it matches new data
      kwitansiRefs.current = [];
    }
    setLoading(false);
  };

  const deleteTransaksiSetoranAngsuranKelompok = async (id) => {
    setLoading(true);
    try {
      await postRequest(
        `/deleteTransaksiSetoranAngsuranKelompok/${id}`,
        {
          kelompokId,
          angsuranKelompokId,
          totalAngsuran,
          bayar,
          penerimaanAngsuranKelompoks,
        },
        navigate,
        dispatch,
      );
      getSetoranAngsuranKelompoks();

      // Angsuran
      setAngsuranKelompokId("");
      setNoKwitansi("");
      setNoKelompok("");
      setNo("");
      setTglJatuhTempo("");
      setAngPerBulan("");
      setTotalAngsuran("");
      setTglBayar("");
      setBayar("");

      navigate("/setoran");
    } catch (error) {
      if (error?.response?.data?.message?.includes("foreign key")) {
        alert(`${noKwitansi} tidak bisa dihapus!`);
      }
    }
    setLoading(false);
  };

  const downloadPdf = () => {
    var date = new Date();
    var current_date =
      date.getDate().toLocaleString("en-US", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      }) +
      "-" +
      (date.getMonth() + 1).toLocaleString("en-US", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      }) +
      "-" +
      date.getFullYear();
    var current_time =
      date.getHours().toLocaleString("en-US", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      }) +
      ":" +
      date.getMinutes().toLocaleString("en-US", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      }) +
      ":" +
      date.getSeconds().toLocaleString("en-US", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      });
    const doc = new jsPDF();
    doc.setFontSize(12);
    doc.text(`${setting.namaPerusahaan} - ${setting.kotaPerusahaan}`, 15, 10);
    doc.text(`${setting.alamatPerusahaan}`, 15, 15);
    doc.setFontSize(16);
    doc.text(`Daftar Setoran Angsuran Kelompok`, 85, 30);
    doc.setFontSize(10);
    doc.text(
      `Dicetak Oleh: ${user.username} | Tanggal : ${current_date} | Jam : ${current_time}`,
      15,
      290,
    );
    doc.autoTable({
      html: "#table",
      startY: doc.pageCount > 1 ? doc.autoTableEndPosY() + 20 : 45,
      headStyles: {
        fillColor: [117, 117, 117],
        color: [0, 0, 0],
      },
    });
    window.open(URL.createObjectURL(doc.output("blob")));
  };

  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "Setoran Angsuran Kelompok",
    sheet: "SetoranPembukaanTabunganUmum",
  });

  // helper: safe filename
  const safeFileName = (name) =>
    String(name || "")
      .replace(/[\\/:*?"<>|]/g, "")
      .replace(/\s+/g, " ")
      .trim();

  // IMPORTANT: generate 1 PDF PER kwitansi (separate files)
  const handleGenerateKwitansiPdfs = async () => {
    const nodes = kwitansiRefs.current.filter(Boolean);

    if (!nodes.length) {
      alert("Tidak ada kwitansi yang bisa dicetak.");
      return;
    }

    // Browser can block multiple downloads; user may need to allow it.
    for (let i = 0; i < nodes.length; i++) {
      const doc = new jsPDF({
        format: "a4",
        unit: "px",
      });

      // eslint-disable-next-line no-await-in-loop
      await new Promise((resolve) => {
        doc.html(nodes[i], {
          html2canvas: { scale: 0.44 },
          callback: () => resolve(),
        });
      });

      const pesertaNama =
        penerimaanAngsuranKelompoks?.[i]?.peserta?.namaPeserta ||
        `peserta-${i + 1}`;
      const filename = safeFileName(
        `kwitansi-${noKwitansi}-${i + 1}-${pesertaNama}.pdf`,
      );

      doc.save(filename);
    }
  };

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  if (loading) {
    return <Loader />;
  }

  if (isFetchError) {
    return <FetchErrorHandling />;
  }

  return (
    <Container>
      {id && (
        <Button
          variant="outlined"
          color="secondary"
          onClick={() => {
            navigate("/setoran");
          }}
          sx={{ marginRight: 2 }}
        >
          {"< Kembali"}
        </Button>
      )}
      <h3>Setoran Angsuran Kelompok</h3>
      <h5 style={{ fontWeight: 400 }}>Daftar Setoran Angsuran Kelompok</h5>

      {!id && (
        <Box sx={downloadButtons}>
          <ButtonGroup variant="outlined" color="secondary">
            <Button
              color="primary"
              startIcon={<SearchIcon />}
              onClick={() => {
                setPreviewPdf(!previewPdf);
                getPenerimaanAngsuranKelompokReportData();
                setPreviewExcel(false);
                setPreviewPdfCetakKwitansi(false);
              }}
            >
              PDF
            </Button>
            <Button
              color="secondary"
              startIcon={<SearchIcon />}
              onClick={() => {
                setPreviewExcel(!previewExcel);
                getPenerimaanAngsuranKelompokReportData();
                setPreviewPdf(false);
                setPreviewPdfCetakKwitansi(false);
              }}
            >
              Excel
            </Button>
          </ButtonGroup>
        </Box>
      )}

      {previewPdf && (
        <div>
          <Button
            variant="outlined"
            startIcon={<PrintIcon />}
            onClick={() => downloadPdf()}
          >
            CETAK
          </Button>
          <table class="table" id="table">
            <thead>
              <tr>
                <th>No</th>
                <th>Tgl. Jatuh Tempo</th>
              </tr>
            </thead>
            <tbody>
              {penerimaanAngsuranKelompokReport.map((penerimaan, index) => {
                return (
                  <tr key={penerimaan.id}>
                    <td>{index + 1}</td>
                    <td>
                      {formatDate(penerimaan.angsurankelompok.tglJatuhTempo)}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}

      <div>
        {previewExcel && (
          <Button
            variant="outlined"
            startIcon={<DownloadIcon />}
            onClick={onDownload}
          >
            EXCEL
          </Button>
        )}
        <table ref={tableRef}>
          {previewExcel && (
            <tbody>
              <tr>
                <th>No</th>
                <th>Tgl Jatuh Tempo</th>
              </tr>
              {penerimaanAngsuranKelompokReport.map((penerimaan, index) => {
                return (
                  <tr key={penerimaan.id}>
                    <td>{index + 1}</td>
                    <td>
                      {formatDate(penerimaan.angsurankelompok.tglJatuhTempo)}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          )}
        </table>
      </div>

      {!id && (
        <Box sx={buttonModifierContainer}>
          <ButtonGroup variant="contained">
            <Button
              color="success"
              sx={{ bgcolor: "success.light", textTransform: "none" }}
              startIcon={<AddCircleOutlineIcon />}
              size="small"
              onClick={() => {
                navigate(`/setoran/tambahSetoran`);
              }}
            >
              Tambah
            </Button>
          </ButtonGroup>
        </Box>
      )}

      {id && (
        <Box sx={downloadButtons}>
          <ButtonGroup variant="outlined" color="secondary">
            <Button
              color="primary"
              startIcon={<SearchIcon />}
              onClick={() => {
                setPreviewPdf(false);
                setPreviewExcel(false);
                setPreviewPdfCetakKwitansi(!previewPdfCetakKwitansi);
              }}
            >
              Cetak Kwitansi
            </Button>
          </ButtonGroup>
        </Box>
      )}

      {id && previewPdfCetakKwitansi && (
        <div>
          <Button
            variant="outlined"
            startIcon={<PrintIcon />}
            onClick={handleGenerateKwitansiPdfs}
          >
            CETAK
          </Button>

          {penerimaanAngsuranKelompoks.map((user, index) => {
            return (
              <div
                key={user?.id ?? index}
                ref={(el) => (kwitansiRefs.current[index] = el)}
                style={cetakContainerKwitansiAngsuran}
              >
                <p style={cetakCenter}>{setting.namaPerusahaan}</p>
                <p style={cetakCenter}>
                  {setting.alamatPerusahaan} ({setting.kabupatenPerusahaan}){" "}
                  {setting.kotaPerusahaan}
                </p>
                <p style={cetakCenter}>NO. TELP. {setting.teleponPerusahaan}</p>
                <hr style={{ marginBottom: "20px" }} />
                <div style={{ display: "flex" }}>
                  <div>
                    <p style={cetakText}>Tanggal</p>
                  </div>
                  <div style={{ marginLeft: "50px" }}>
                    <p style={cetakText}>: {formatDate(tglBayar)}</p>
                  </div>
                </div>
                <div style={{ display: "flex" }}>
                  <div>
                    <p style={cetakText}>No. Kwitansi</p>
                  </div>
                  <div style={{ marginLeft: "22px" }}>
                    <p style={cetakText}>: {noKwitansi}</p>
                  </div>
                </div>
                <div style={{ marginTop: "10px" }}>
                  <p style={cetakCenterBold}>BUKTI PEMBAYARAN</p>
                </div>
                <div style={{ marginTop: "10px" }}>
                  <div style={{ display: "flex" }}>
                    <div>
                      <p style={cetakText}>Peserta</p>
                    </div>
                    <div style={{ marginLeft: "80px" }}>
                      <p style={cetakText}>: {user?.peserta?.namaPeserta}</p>
                    </div>
                  </div>
                  <div style={{ display: "flex" }}>
                    <div>
                      <p style={cetakText}>Tgl. Pembayaran</p>
                    </div>
                    <div style={{ marginLeft: "22px" }}>
                      <p style={cetakText}>: {formatDate(tglBayar)}</p>
                    </div>
                  </div>
                  <div style={{ display: "flex" }}>
                    <div>
                      <p style={cetakText}>No. Kelompok</p>
                    </div>
                    <div style={{ marginLeft: "42px" }}>
                      <p style={cetakText}>: {noKelompok}</p>
                    </div>
                  </div>
                  <div style={{ display: "flex" }}>
                    <div>
                      <p style={cetakText}>Tgl. Jatuh Tempo</p>
                    </div>
                    <div style={{ marginLeft: "22px" }}>
                      <p style={cetakText}>: {formatDate(tglJatuhTempo)}</p>
                    </div>
                  </div>
                  <div style={{ display: "flex" }}>
                    <div>
                      <p style={cetakText}>Setoran Ke</p>
                    </div>
                    <div style={{ marginLeft: "60px" }}>
                      <p style={cetakText}>
                        : {no} ({angkaTerbilang(no)})
                      </p>
                    </div>
                  </div>
                </div>
                <hr style={{ marginBottom: "20px" }} />
                <div style={cetakWrapper}>
                  <p>Keterangan</p>
                  <p>Nominal</p>
                </div>
                <hr style={{ marginTop: "0px" }} />
                <div style={cetakWrapperNoMarginTop}>
                  <p>Bayar</p>
                  <p>
                    {user?.setoranangsurankelompok?.angsurankelompok?.angPerBulan?.toLocaleString(
                      "de-DE",
                    )}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      )}

      <Box sx={buttonModifierContainer}>
        <ButtonModifier
          id={id}
          kode={id}
          // editLink={`/setoran/${id}/edit`}
          editLink={null}
          deleteUser={deleteTransaksiSetoranAngsuranKelompok}
          nameUser={no}
        />
      </Box>

      {id && (
        <Container>
          <hr />
          <Form>
            <Box sx={showDataContainer}>
              <Box sx={showDataWrapper}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        No. Kwitansi :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control disabled value={noKwitansi} />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        No. Kelompok :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control disabled value={noKelompok} />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        No :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control disabled value={no} />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Tgl. Jatuh Tempo :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          value={formatDate(tglJatuhTempo)}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Setoran/Bulan :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          value={angPerBulan.toLocaleString("en-US")}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Tgl. Bayar :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          value={formatDate(tglBayar)}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Total :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          value={totalAngsuran.toLocaleString("en-US")}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Bayar :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          value={bayar.toLocaleString("en-US")}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>

              <Box sx={[showDataWrapper, secondWrapper]}></Box>
            </Box>
          </Form>
        </Container>
      )}

      <hr />

      {id && (
        <Box sx={tableContainer}>
          <ShowTableTampilPenerimaanAngsuranKelompok
            currentPosts={penerimaanAngsuranKelompoks}
          />
        </Box>
      )}

      {!id && (
        <>
          <Form onSubmit={searchData}>
            <Box sx={searchBarContainer}>
              <SearchBar value={query} setSearchTerm={setQuery} />
              <Button
                variant="contained"
                type="submit"
                color="primary"
                disableElevation
              >
                Cari
              </Button>
            </Box>
          </Form>

          <Box sx={tableContainer}>
            <ShowTableSetoranAngsuranKelompok
              currentPosts={setoranAngsuranKelompoks}
            />
          </Box>

          <Box sx={tableContainer}>
            <Pagination
              count={pages}
              page={page + 1}
              onChange={handleChange}
              color="primary"
              size={screenSize <= 600 ? "small" : "large"}
            />
          </Box>
        </>
      )}
    </Container>
  );
};

export default TampilSetoranAngsuranKelompok;

const buttonModifierContainer = {
  mt: 4,
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
};

const downloadButtons = {
  mt: 4,
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
};

const searchBarContainer = {
  pt: 6,
  display: "flex",
  justifyContent: "center",
};

const tableContainer = {
  pt: 4,
  display: "flex",
  justifyContent: "center",
};

const pdfContainer = {
  padding: "20px",
  letterSpacing: "0.01px",
  fontSize: "12px",
  fontFamily: "sans-serif",
  width: "1000px",
};

const titleCetak = {
  textAlign: "center",
  fontWeight: "bold",
  marginTop: "20px",
};

const noTandaTerimaCetak = {
  textAlign: "center",
  fontWeight: "500",
};

const containerContent = {
  display: "flex",
  marginLeft: "120px",
};

const containerContentRight = {
  display: "flex",
  marginLeft: "460px",
  marginTop: "-20px",
};

const wrapperContent = {
  marginTop: "20px",
  width: "800px",
  fontSize: "15px",
};

const numberContent = {
  marginLeft: "20px",
  width: "100px",
  display: "flex",
  justifyContent: "right",
};

const thirdNumberContent = {
  display: "flex",
  marginLeft: "20px",
  marginTop: "-15px",
};

const totalContainer = {
  display: "flex",
  marginLeft: "20px",
  marginTop: "-15px",
};

const totalText = {
  marginLeft: "110px",
  marginRight: "46px",
  fontWeight: "bold",
};

const totalWrapper = {
  display: "flex",
  height: "20px",
  borderBottom: "1px solid black",
};

const totalNumber = {
  marginLeft: "20px",
  width: "100px",
  display: "flex",
  justifyContent: "right",
};

const showDataContainer = {
  mt: 4,
  display: "flex",
  flexDirection: {
    xs: "column",
    sm: "row",
  },
};

const showDataWrapper = {
  display: "flex",
  flex: 1,
  flexDirection: "column",
  maxWidth: {
    md: "40vw",
  },
};

const secondWrapper = {
  marginLeft: {
    sm: 4,
  },
  marginTop: {
    sm: 0,
    xs: 4,
  },
};

const cetakContainerKwitansiAngsuran = {
  fontSize: "14px",
  letterSpacing: "0.01px",
  fontFamily: "sans-serif",
  width: "330px",
  padding: "20px",
  // marginLeft: "35px",
  marginLeft: "15px",
};

const cetakCenter = {
  // fontSize: "12px",
  fontSize: "14px",
  textAlign: "center",
  marginTop: "0px",
  marginBottom: "0px",
};

const cetakText = {
  // fontSize: "12px",
  fontSize: "14px",
  marginTop: "0px",
  marginBottom: "0px",
};

const cetakCenterBold = {
  textAlign: "center",
  marginTop: "0px",
  marginBottom: "0px",
  fontWeight: "700",
  // fontSize: "12px",
  fontSize: "14px",
};

const cetakWrapper = {
  // fontSize: "12px",
  fontSize: "14px",
  display: "flex",
  justifyContent: "space-between",
};

const cetakWrapperNoMarginTop = {
  // fontSize: "12px",
  fontSize: "14px",
  display: "flex",
  justifyContent: "space-between",
  marginTop: "-10px",
};
